import { Typography, TypographyType } from '../typography';
import * as React from 'react';

interface LabelShowingResultsProps {
	total: number;
	totalItems: number;
	isSearched?: boolean;
	labelTotalItems: string;
	typographyType?: TypographyType;
	keepLabelTotalItems?: boolean;
	allowDynamicUpdate?: boolean;
}
export const LabelShowingResults: React.FC<LabelShowingResultsProps> = ({
	total,
	totalItems,
	isSearched,
	labelTotalItems,
	typographyType = 'regular-12',
	keepLabelTotalItems = false,
	allowDynamicUpdate = false,
}) => {
	const totalRecords = React.useRef<number | null>(null);

	const displayedTotal = React.useMemo(() => {
		if (allowDynamicUpdate) {
			return totalItems;
		}

		// "Freeze" totalItems on first call
		if (totalRecords.current === null && totalItems) {
			totalRecords.current = totalItems;
		}

		return totalRecords.current ?? 0;
	}, [totalItems, allowDynamicUpdate]);

	return (
		<Typography
			type={typographyType}
			className="opacity-60 block xl:whitespace-nowrap"
		>
			{isSearched
				? `Showing ${total} ${
						totalItems === 1 ? 'result' : 'results'
				  } of ${displayedTotal} ${
						displayedTotal === 1
							? keepLabelTotalItems
								? labelTotalItems
								: labelTotalItems.slice(0, -1)
							: labelTotalItems
				  }`
				: `Showing ${total} of ${displayedTotal} ${
						displayedTotal === 1
							? keepLabelTotalItems
								? labelTotalItems
								: labelTotalItems.slice(0, -1)
							: labelTotalItems
				  }`}
		</Typography>
	);
};
